import * as ApplicationActions from '../types/applicationTypes';
import { ApplicationType } from 'redux/types/storeTypes';

const initialState: ApplicationType = {
  loading: false,
  error: undefined,
  items: []
};

const applicationItemsFrom = (payload: any) => {
  const candidate =
    payload?.applications ?? payload?.data ?? payload?.items ?? payload;
  return Array.isArray(candidate) ? candidate : [];
};

const applicationReducer = (state = initialState, action: { [key: string]: any }) => {

  switch (action.type) {

    case ApplicationActions.GET_APPLICATIONS_START:
      return {
        ...state,
        error: undefined,
        loading: true,
      };

    case ApplicationActions.GET_APPLICATIONS_SUCCESS:
      return {
        ...state,
        items: applicationItemsFrom(action.payload),
        loading: false,
      };

    case ApplicationActions.GET_APPLICATIONS_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    default:
      return state;
  }
};

export default applicationReducer;
